import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../../dist/asyncToGenerator-c002e3ca.esm.js';
import { _ as _objectSpread2 } from '../../../../dist/objectSpread2-a26147ce.esm.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import Hls from 'hls.js';
import { i as isClient } from '../../../../dist/utils-1cd6e65a.esm.js';
import '../../../../dist/defineProperty-e24c82ea.esm.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';

// deprecated! - all errors trigger exponential backoff
// keeping for documentation
//
// errors which trigger an exponential backoff
// const backoffRetryErrors = [
//   // custom error to indicate invalid JWT was provided
//   'Shutting down since this session is not allowed to view this stream',
//   // custom error to indicate stream could not be opened
//   'Stream open failed',
// ] as const;

var VIDEO_HLS_INITIALIZED_ATTRIBUTE = 'data-hls-initialized';
/**
 * Checks if hls.js can play in the browser.
 */
var isHlsSupported = function isHlsSupported() {
  return isClient() ? Hls.isSupported() : true;
};
var retryCount = 0;

/**
 * Create an hls.js instance and attach to the provided media element.
 */
var createNewHls = function createNewHls(source, element, callbacks, config) {
  // do not attach twice
  if (element.getAttribute(VIDEO_HLS_INITIALIZED_ATTRIBUTE) === 'true') {
    return {
      destroy: function destroy() {
        //
      }
    };
  }
  element.setAttribute(VIDEO_HLS_INITIALIZED_ATTRIBUTE, 'true');
  var hls = new Hls(_objectSpread2({
    maxBufferLength: 15,
    maxMaxBufferLength: 60,
    liveMaxLatencyDurationCount: 7,
    liveSyncDurationCount: 3
  }, config));
  var onDestroy = function onDestroy() {
    var _hls$destroy, _element$removeAttrib;
    hls === null || hls === void 0 ? void 0 : (_hls$destroy = hls.destroy) === null || _hls$destroy === void 0 ? void 0 : _hls$destroy.call(hls);
    element === null || element === void 0 ? void 0 : (_element$removeAttrib = element.removeAttribute) === null || _element$removeAttrib === void 0 ? void 0 : _element$removeAttrib.call(element, VIDEO_HLS_INITIALIZED_ATTRIBUTE);
  };
  if (element) {
    hls.attachMedia(element);
  }
  hls.on(Hls.Events.LEVEL_LOADED, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_e, data) {
      var _callbacks$onLive, _callbacks$onDuration;
      var _data$details, live, duration;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _data$details = data.details, live = _data$details.live, duration = _data$details.totalduration;
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onLive = callbacks.onLive) === null || _callbacks$onLive === void 0 ? void 0 : _callbacks$onLive.call(callbacks, Boolean(live));
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onDuration = callbacks.onDuration) === null || _callbacks$onDuration === void 0 ? void 0 : _callbacks$onDuration.call(callbacks, duration !== null && duration !== void 0 ? duration : 0);
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  hls.on(Hls.Events.MEDIA_ATTACHED, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            hls.loadSource(source);
            hls.on(Hls.Events.MANIFEST_PARSED, function (_event, _data) {
              var _callbacks$onCanPlay;
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onCanPlay = callbacks.onCanPlay) === null || _callbacks$onCanPlay === void 0 ? void 0 : _callbacks$onCanPlay.call(callbacks);
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  hls.on(Hls.Events.ERROR, /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_event, data) {
      var _callbacks$onError;
      var type, details, fatal, isFatalNetworkError, isFatalMediaError, isManifestParsingError;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              type = data.type, details = data.details, fatal = data.fatal;
              isFatalNetworkError = type === Hls.ErrorTypes.NETWORK_ERROR && fatal;
              isFatalMediaError = type === Hls.ErrorTypes.MEDIA_ERROR && fatal;
              isManifestParsingError = Hls.ErrorTypes.NETWORK_ERROR && details === 'manifestParsingError';
              if (!(!fatal && !isManifestParsingError)) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              callbacks === null || callbacks === void 0 ? void 0 : (_callbacks$onError = callbacks.onError) === null || _callbacks$onError === void 0 ? void 0 : _callbacks$onError.call(callbacks, data);
              if (!(isFatalNetworkError || isFatalMediaError || isManifestParsingError)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 10;
              return new Promise(function (r) {
                return setTimeout(r, 1000 * ++retryCount);
              });
            case 10:
              hls === null || hls === void 0 ? void 0 : hls.recoverMediaError();
            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }());
  return {
    destroy: onDestroy
  };
};

export { VIDEO_HLS_INITIALIZED_ATTRIBUTE, createNewHls, isHlsSupported };
